import { beneficiosInfluencer } from '../../../mocks/influencers-parceiros';

export default function BeneficiosInfluencer() {
  return (
    <section id="beneficios" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-5 py-2 bg-amber-100 rounded-full mb-6">
            <i className="ri-gift-line text-amber-600"></i>
            <span className="text-sm font-semibold text-amber-800 tracking-wide">BENEFÍCIOS EXCLUSIVOS</span>
          </div>
          <h2 className="font-playfair text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            O Que Você Ganha Como
            <span className="block text-amber-600 mt-2">Parceira Oficial</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Muito mais do que acesso gratuito. Você se torna parte de um movimento de transformação.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {beneficiosInfluencer.map((beneficio, index) => (
            <div 
              key={index}
              className="group p-8 bg-gradient-to-br from-amber-50 to-white rounded-2xl border border-amber-100 hover:shadow-2xl hover:scale-105 transition-all duration-300 cursor-pointer"
            >
              {/* Icon */}
              <div className="w-16 h-16 bg-gradient-to-br from-amber-500 to-amber-600 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className={`${beneficio.icone} text-3xl text-white`}></i>
              </div>

              {/* Content */}
              <h3 className="font-playfair text-2xl font-bold text-gray-900 mb-3">
                {beneficio.titulo}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {beneficio.descricao}
              </p>
            </div>
          ))}
        </div>

        {/* Extra Info */}
        <div className="mt-16 p-8 bg-gradient-to-r from-amber-100 via-rose-50 to-amber-100 rounded-3xl border border-amber-200">
          <div className="flex flex-col md:flex-row items-center gap-6">
            <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center flex-shrink-0">
              <i className="ri-star-fill text-4xl text-amber-600"></i>
            </div>
            <div className="text-center md:text-left flex-1">
              <h3 className="font-playfair text-2xl font-bold text-gray-900 mb-2">
                Parceria de Verdade
              </h3>
              <p className="text-gray-700 leading-relaxed">
                Não é apenas um código de desconto. É uma parceria real onde você faz parte da jornada de transformação das pessoas e recebe todo o suporte da Bia Holmes.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}